<div class="input-group">
    <span class="input-group-text">
        <nb-icon icon="fa-flag"></nb-icon>
    </span>
    <select
        [disabled]="isDisabled"
        autocomplete="false"
        type="country"
        id="country"
        class="form-control"
        (change)="countryChanged()"
        [(ngModel)]="selectedCountry"
        [compareWith]="compareCountry"
    >
        <option *ngFor="let country of allCountries" [ngValue]="country">
            {{ country.LocalName }}
        </option>
    </select>
</div>
